export const META_MISSING = 'META_MISSING';
export const PARSE_FAIL = 'PARSE_FAIL';
export const NO_IMAGE_FILES = 'NO_IMAGE_FILES';
export const NON_IMAGE_FILE_SIZE = 'NON_IMAGE_FILE_SIZE';
